import { autoinject } from 'aurelia-framework';
import {
	NavigationInstruction,
	Next,
	PipelineStep,
	RedirectToRoute,
} from 'aurelia-router';
import { StateHistory, Store } from 'aurelia-store';

import { AppActions } from '~/app-actions';
import { AppRouteID } from '~/app-routes';
import { AppState } from '~/app-store';
import { BrowserCheck } from '~/components/browser-check/browser-check';
import { clearLocalLoginData } from '~/utils/local-storage';

@autoinject
export class BrowserCheckStep implements PipelineStep {
	constructor(private readonly store: Store<StateHistory<AppState>>) {}

	public run(
		navigationInstruction: NavigationInstruction,
		next: Next,
	): Promise<any> {
		if (
			BrowserCheck.checkIfSupportedBrowser() &&
			navigationInstruction.config.name !== AppRouteID.Login
		) {
			clearLocalLoginData();
			this.store.dispatch(AppActions.ResetState);
			return next.cancel(new RedirectToRoute(AppRouteID.Login));
		}
		return next();
	}
}
